import { render, staticRenderFns } from "./shopComment.vue?vue&type=template&id=5ef1544e&"
import script from "./shopComment.vue?vue&type=script&lang=js&"
export * from "./shopComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports